/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ChartDataEnum {
    PortfolioValue = 'portfolioValue',
    ExternalValue = 'externalValue',
    PinnedPortfolioValue = 'pinnedPortfolioValue'
}

export function ChartDataEnumFromJSON(json: any): ChartDataEnum {
    return ChartDataEnumFromJSONTyped(json, false);
}

export function ChartDataEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChartDataEnum {
    return json as ChartDataEnum;
}

export function ChartDataEnumToJSON(value?: ChartDataEnum | null): any {
    return value as any;
}

